'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { OptimizedImage } from '@/components/images/optimized-image';
import { useOutcomeColor } from '@/hooks/chart/use-outcome-color';
import { SettledSeal } from './settled-seal';
interface WinnerIdentityHeaderProps {
  marketPubkey: string;
  outcomeIndex: number;
  name: string;
  imageUrl: string | null;
  imageNsfw: boolean;
  imageAlt: string;
  status: ReactNode;
  showSettledBadge?: boolean;
}

/** Shared winning-token identity for the trade card and Winner tab. */
export function WinnerIdentityHeader(t0) {
  const $ = _c(27);
  const {
    marketPubkey,
    outcomeIndex,
    name,
    imageUrl,
    imageNsfw,
    imageAlt,
    status,
    showSettledBadge: t1
  } = t0;
  const showSettledBadge = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== name || $[1] !== outcomeIndex) {
    t2 = {
      title: name,
      index: outcomeIndex
    };
    $[0] = name;
    $[1] = outcomeIndex;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== marketPubkey) {
    t3 = {
      marketPubkey
    };
    $[3] = marketPubkey;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    hue
  } = useOutcomeColor(t2, t3);
  const t4 = imageUrl !== null && imageUrl !== "" ? imageUrl : null;
  let t5;
  if ($[5] !== hue || $[6] !== imageNsfw || $[7] !== marketPubkey || $[8] !== outcomeIndex || $[9] !== t4) {
    t5 = {
      kind: "outcome",
      marketPubkey,
      outcomeIndex,
      hue,
      imageUrl: t4,
      nsfw: imageNsfw
    };
    $[5] = hue;
    $[6] = imageNsfw;
    $[7] = marketPubkey;
    $[8] = outcomeIndex;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== imageAlt || $[12] !== t5) {
    t6 = <OptimizedImage variant="thumbnail" entity={t5} alt={imageAlt} size="size-14" rounded="rounded-control" preview={false} />;
    $[11] = imageAlt;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== showSettledBadge) {
    t7 = showSettledBadge && <SettledSeal className="pointer-events-none absolute -bottom-2.5 -right-2.5 z-10 size-9" />;
    $[14] = showSettledBadge;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className="relative shrink-0">{t6}{t7}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== name) {
    t9 = <span className="truncate text-heading text-foreground-primary">{name}</span>;
    $[19] = name;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== status || $[22] !== t9) {
    t10 = <div className="flex min-w-0 flex-col gap-1">{t9}{status}</div>;
    $[21] = status;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t8) {
    t11 = <div className="flex items-center gap-4">{t8}{t10}</div>;
    $[24] = t10;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
}